var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53,
    height: 42,
    viewBox: "0 0 53 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_818",
    "data-name": "\\uC0AC\\uAC01\\uD615 818",
    width: 18.412,
    height: 17.566,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uB85C\\uADF8\\uC778",
    transform: "translate(16.389 27.662)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_802",
    "data-name": "\\uC0AC\\uAC01\\uD615 802",
    width: 53,
    height: 42,
    transform: "translate(-16.389 -27.662)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uB85C\\uADF8\\uC778-2",
    "data-name": "\\uB85C\\uADF8\\uC778",
    transform: "translate(0.611 -15.698)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_2208",
    "data-name": "\\uADF8\\uB8F9 2208",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3657",
    "data-name": "\\uD328\\uC2A4 3657",
    d: "M21.816,17.566a8.766,8.766,0,0,1-6.727-3.138A.989.989,0,1,1,16.6,13.156a6.805,6.805,0,1,0,0-8.747.989.989,0,1,1-1.514-1.272,8.782,8.782,0,1,1,6.727,14.428",
    transform: "translate(-12.186 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3658",
    "data-name": "\\uD328\\uC2A4 3658",
    d: "M11.177,45.332H.989a.989.989,0,1,1,0-1.977H11.177a.989.989,0,1,1,0,1.977",
    transform: "translate(0 -35.561)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3659",
    "data-name": "\\uD328\\uC2A4 3659",
    d: "M48.8,32.132a.987.987,0,0,1-.822-.438L46.038,28.8a.989.989,0,0,1,1.642-1.1l1.942,2.893a.989.989,0,0,1-.82,1.54",
    transform: "translate(-37.624 -22.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_3660",
    "data-name": "\\uD328\\uC2A4 3660",
    d: "M46.858,48.225a.989.989,0,0,1-.82-1.54l1.942-2.893a.989.989,0,0,1,1.642,1.1L47.68,47.787a.988.988,0,0,1-.822.438",
    transform: "translate(-37.624 -35.56)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.d59042b5d83b1263df1dd3eeaf8352b9.svg";
export { ForwardRef as ReactComponent };